import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import { relative } from "path";
import Confirmation from "../App/Confirmation";
import { DownloadClientsDataInExcel, SanitizeHtml, getAccessSettings } from "../Shared/Utility";

function ProgramList() {
  const globalState = useGlobalState();

  const [programGridData, setProgramGridData] = useState([]);
  const [programSectionGridData, setProgramSectionGridData] = useState([]);
  const [programPFIDealerGridData, setProgramPFIDealerGridData] = useState(
    []
  ) as any;
  const [PFIDealerGridData, setPFIDealerGridData] = useState([]) as any;
  const [ibbFormulaGridData, setIBBFormulaGridData] = useState([]) as any;

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  {
    /*MM:: 1 means grid view.. 2 means add view and 3 means edit view*/
  }

  const [departmentList, setDepartmentList] = useState({}) as any;
  const [programData, setProgramData] = useState({}) as any;
  const [programSectionData, setProgramSectionData] = useState({}) as any;

  const [
    submitForApprovalConfirmationModal,
    setSubmitForApprovalConfirmationModal,
  ] = useState(false);

  const [programSectionModal, setProgramSectionModal] = useState(false);
  const [programPFIDealerModal, setProgramPFIDealerModal] = useState(false);

  //MM:: Approval related data
  const [requiredApproval, setRequiredApproval] = useState([]) as any;
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;
  const [approvalDataModal, setApprovalDataModal] = useState(false);
  const [approvalData, setApprovalData] = useState({}) as any;

  //MM:: LoggedInUserID
  const [LoggedInUserID, setLoggedInUserID] = useState(0);

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  const [selectUnSelectAll, setSelectUnSelectAll] = useState<any>(true);

  useEffect(() => {
    if (!globalState.ManageAdmin) {
      window.location.href = "scorecard";
    }

    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
      if (IBBProgramID > 0) setCurrentView(4);
    } else IBBProgramID = programData.IBBProgramID;

    setProgramData((prevState: any) => ({
      ...prevState,
      IBBProgramID: IBBProgramID,
    }));

    IBBProgramGetCompleteGridDataCustom(IBBProgramID);
    IBBDepartmentGetCompleteGridDataCustom();
  }, []);

  useEffect(() => {
    calculateTotalAssignedPercentage();
  }, [programSectionGridData]);

  useEffect(() => {
    checkPFIDealerAlreadyInProgram(programPFIDealerGridData);
  }, [programPFIDealerGridData]);

  function IBBDepartmentGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartment/IBBDepartmentGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setDepartmentList(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetCompleteGridDataCustom(IBBProgramID: number = 0) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setProgramGridData(result[1]);
          if (IBBProgramID > 0 && result.length > 1 && result[1].length > 0) {
            let filtered = result[1].filter(
              (item: any) => item.IBBProgramID == IBBProgramID
            );
            if (filtered.length > 0) {
              setProgramData(filtered[0]);

              IBBProgramSectionGetCompleteGridDataCustom(IBBProgramID);
              IBBProgramPFIDealerGetCompleteGridDataCustom(IBBProgramID);
              if (filtered[0].Status == 0) setCanEdit(true);
              else {
                setCanEdit(false);

                IBBRequiredApprovalUserGetDataForApproval(
                  IBBProgramID,
                  filtered[0].SubStatus
                );
              }
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSaveCustom(FilesData: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = programData.IBBProgramID;
    object.name = SanitizeHtml(programData.Name);
    object.description = programData.Description;
    object.numericyear = programData.NumericYear;
    object.filesdata = FilesData;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBProgram/IBBProgramSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;

          if (result.length > 0 && result[0].length > 0) {
            let DBPKID = result[0][0].DBPKID;
            if (programData.IBBProgramID == 0) {
              IBBProgramPFIDealerGetCompleteGridDataCustom(DBPKID);
            }
            setProgramData((prevState: any) => ({
              ...prevState,
              IBBProgramID: DBPKID,
            }));
            IBBProgramGetCompleteGridDataCustom();
            setCurrentView(1);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramDeleteRecordCustom(IBBProgramID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBProgram/IBBProgramDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramUpdateStatusAndSubStatus(
    Status: number,
    SubStatus: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = programData.IBBProgramID;
    object.status = Status;
    object.substatus = SubStatus;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramUpdateStatusAndSubStatus",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          IBBProgramGetCompleteGridDataCustom();
          setCurrentView(1);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSectionGetCompleteGridDataCustom(ibbprogramid: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = ibbprogramid;
    object.isdeleted = false;
    object.recordsperpage = 100;
    object.sortexpressions = "Type";
    object.sortdirection = "A";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramSection/IBBProgramSectionGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          let reEarnables = result[1]; //[1].filter((item: any) => item.Type == 2);
          setProgramSectionGridData(reEarnables);
          setSubmitForApprovalConfirmationModal(false);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSectionSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = programData.IBBProgramID;
    object.ibbdepartmentid = programSectionData.IBBDepartmentID;
    object.ibbprogramsectionid = programSectionData.IBBProgramSectionID;
    object.title = programSectionData.Title;
    object.shorttitle = programSectionData.ShortTitle;
    object.description = programSectionData.Description;
    object.type = programSectionData.Type;
    object.value = programSectionData.Value;
    object.valuedescription = programSectionData.ValueDescription;
    object.ptorderby = programSectionData.PTOrderBy;
    object.extratextfield1 = programSectionData.ExtraTextField1;
    object.extratextfield2 = programSectionData.ExtraTextField2;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramSection/IBBProgramSectionSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setProgramSectionModal(false);
          IBBProgramSectionGetCompleteGridDataCustom(programData.IBBProgramID);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSectionDeleteRecordCustom(IBBProgramSectionID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramsectionid = IBBProgramSectionID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramSection/IBBProgramSectionDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramSectionGetCompleteGridDataCustom(programData.IBBProgramID);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function calculateTotalAssignedPercentage() {
    const totalPercentage = programSectionGridData.reduce(
      (total, item: any) => (total = total + item.Value),
      0
    );
    setProgramSectionData((prevState: any) => ({
      ...prevState,
      TotalPercentage: totalPercentage,
    }));
  }

  function IBBProgramPFIDealerGetCompleteGridDataCustom(ibbprogramid: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = ibbprogramid;
    object.recordsperpage = 100;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramPFIDealer/IBBProgramPFIDealerGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setProgramPFIDealerGridData(result[0]);
          setPFIDealerGridData(result[1]);
          setIBBFormulaGridData(result[2]);
          checkPFIDealerAlreadyInProgram(result[0]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramPFIDealerSaveCustom(
    IBBProgramPFIDealerID: number,
    IBBProgramID: number,
    PFIDealerID: number,
    IBBFormulaIDForJaguar: number,
    IBBFormulaIDForLandRover: number,
    IsDeleted: boolean
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogrampfidealerid = IBBProgramPFIDealerID;
    object.ibbprogramid = IBBProgramID;
    object.pfidealerid = PFIDealerID;
    object.ibbformulaidforjaguar = IBBFormulaIDForJaguar;
    object.ibbformulaidforlandrover = IBBFormulaIDForLandRover;
    object.isdeleted = IsDeleted;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramPFIDealer/IBBProgramPFIDealerSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramPFIDealerGetCompleteGridDataCustom(IBBProgramID);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function checkPFIDealerAlreadyInProgram(programPFIDealerGridDataParam: any) {
    let PFIDealerGridDataLocal = PFIDealerGridData;
    for (let i = 0; i < PFIDealerGridDataLocal.length; i++) {
      let PFIDealerID = PFIDealerGridDataLocal[i].PFIDealerID;
      var filtered = programPFIDealerGridDataParam.filter(
        (item: any) => item.PFIDealerID == PFIDealerID
      );
      if (filtered.length > 0) {
        PFIDealerGridDataLocal[i].IsChecked = true;
        PFIDealerGridDataLocal[i].IsDeleted = false;
        PFIDealerGridDataLocal[i].IBBProgramPFIDealerID =
          filtered[0].IBBProgramPFIDealerID;
        PFIDealerGridDataLocal[i].IBBFormulaIDForJaguar =
          filtered[0].IBBFormulaIDForJaguar;
      } else {
        PFIDealerGridDataLocal[i].IsChecked = false;
        PFIDealerGridDataLocal[i].IsDeleted = true;
        PFIDealerGridDataLocal[i].IBBProgramPFIDealerID = 0;
        PFIDealerGridDataLocal[i].IBBFormulaIDForJaguar = 0;
      }
    }
    if (PFIDealerGridDataLocal.length > 0)
      setPFIDealerGridData(PFIDealerGridDataLocal);
  }

  function updateImporterListInProgram(
    index: number,
    type: number,
    value: any
  ) {
    let PFIDealerGridDataLocal = [...PFIDealerGridData] as any;
    if (type == 1) {
      PFIDealerGridDataLocal[index].IsChecked = value;
      PFIDealerGridDataLocal[index].IsDeleted = !value;
    } else {
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar = value;
      PFIDealerGridDataLocal[index].IBBFormulaIDForLandRover = value;
    }
    IBBProgramPFIDealerSaveCustom(
      PFIDealerGridDataLocal[index].IBBProgramPFIDealerID,
      programData.IBBProgramID,
      PFIDealerGridDataLocal[index].PFIDealerID,
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar,
      PFIDealerGridDataLocal[index].IBBFormulaIDForJaguar,
      PFIDealerGridDataLocal[index].IsDeleted
    );
    setPFIDealerGridData(PFIDealerGridDataLocal);
  }

  function IBBRequiredApprovalUserGetDataForApproval(
    IBBProgramID: number,
    SubStatus: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = programData.IBBProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.ibbprogramstageid = SubStatus;
    object.ibbprogramsectionid = 0;
    object.ibbrequiredapprovalid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBRequiredApprovalUser/IBBRequiredApprovalUserGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setRequiredApproval(result[0]);
          setRequiredApprovalUser(result[1]);
          if (result.length > 2 && result[2].length > 0) {
            let userID = result[2][0].UserID;
            //userID = 235;
            setLoggedInUserID(userID);

            //console.log("userID: " + userID);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeApprovalFile,
    MaxAllowedFiles: 1,
    UploadType: 3,
    FolderName: "IBB-Approval-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles(ObjectType: number, ObjectID: number) {
    var ApprovalFile = AppContext.FileUploadObjectTypeApprovalFile;
    var ProgramPolicy = AppContext.FileUploadObjectTypeProgramPolicy;

    if (uploadFileList && uploadFileList.length > 0)
      SaveFiles(ObjectType, ObjectID);
    else if (ObjectType == ApprovalFile) IBBApprovalSaveCustom([]);
    else if (ObjectType == ProgramPolicy)
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please select file to upload.",
      });
  }

  function SaveFiles(ObjectType: number, ObjectID: number) {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = ObjectType;
      object.objectid = ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            var ApprovalFile = AppContext.FileUploadObjectTypeApprovalFile;
            var ProgramPolicy = AppContext.FileUploadObjectTypeProgramPolicy;
            if (ObjectType == ApprovalFile) IBBApprovalSaveCustom(l_response);
            else if (ObjectType == ProgramPolicy)
              IBBProgramSaveCustom(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      //saveConactUsData([]);
    }
  }
  //Dragdrop ends

  function IBBApprovalSaveCustom(uploadedFileList: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbrequiredapprovaluserid = approvalData.IBBRequiredApprovalUserID;
    object.name = approvalData.Name;
    object.status = approvalData.Status;
    object.notes = approvalData.Notes;
    object.objecttype = programData.Status;
    object.objectid = programData.SubStatus;
    object.signaturedata = approvalData.SignatureData;
    object.filesdata = uploadedFileList;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBApproval/IBBApprovalSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setApprovalDataModal(false);
          IBBRequiredApprovalUserGetDataForApproval(
            programData.IBBProgramID,
            programData.SubStatus
          );
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function sendProgramPolicyDocumentToImporters() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = programData.IBBProgramID;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramSendPolicyDocumentToImporters",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function selectUnselectAll(event: any) {
    let l_currentList = [...PFIDealerGridData];
    if (event.target.checked) {
      //select all
      setSelectUnSelectAll(true);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsChecked = true;
      }
    } else {
      //unselect all
      setSelectUnSelectAll(false);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsChecked = false;
      }
    }
    IBBProgramPFIDealerSaveCustomAll(programData.IBBProgramID, l_currentList);
    setPFIDealerGridData(l_currentList);
  }

  useEffect(() => {
    if (PFIDealerGridData && PFIDealerGridData.length > 0)
      checkSelectUnselectAll();
  }, [PFIDealerGridData]);

  function checkSelectUnselectAll() {
    let allChecked = true;
    for (let i = 0; i < PFIDealerGridData.length; i++) {
      if (
        PFIDealerGridData[i].IsChecked === false ||
        PFIDealerGridData[i].IsChecked == undefined
      ) {
        allChecked = false;
        break;
      }
    }
    setSelectUnSelectAll(allChecked);
  }

  function IBBProgramPFIDealerSaveCustomAll(
    IBBProgramID: number,
    DealersList: any
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    object.dealerslist = DealersList;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramPFIDealer/IBBProgramPFIDealerSaveCustomAll",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramPFIDealerGetCompleteGridDataCustom(IBBProgramID);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBProgramDeleteRecordCustom(obj.SelectedID);
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        IBBProgramSectionDeleteRecordCustom(obj.SelectedID);
      }
    }

    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }


  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Program List</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <span></span>
              <div className="flex-items">
              {getAccessSettings(2, 18) > 1 && (
                <a
                  className="btn-link"
                  onClick={() => {
                    setProgramData({});
                    setProgramSectionGridData([]);
                    setProgramPFIDealerGridData([]);
                    setCurrentView(2);
                    setCanEdit(true);
                  }}
                >
                  Add Program
                </a>
              )}

              <a
                className="btn-primary"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblProgramList", "ProgramList")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
              </div>
            </div>
            <div className="section-table">
              <table className="part-head trend-table fixed-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    {/* <th>Description</th> */}
                    <th>Total Percentage</th>
                    <th>Importer #</th>
                    <th>Year</th>
                    <th className="md-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {programGridData &&
                    programGridData.map((item: any, index: any) => (
                      <React.Fragment key={"program" + index}>
                        <tr>
                          <td>{item.Name}</td>
                          {/* <td>{item.Description}</td> */}
                          <td className="text-right">
                            {item.TotalPercentage?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </td>
                          <td className="text-right">{item.ImporterCount}</td>
                          <td className="text-right">{item.NumericYear}</td>
                          <td className="md-col">
                            <div
                              className="width-100 text-center btn-sm-grid"
                              style={{ justifyContent: "flex-start" }}
                            >
                              {getAccessSettings(2, 18) > 1 && (
                                <a
                                  className="btn-primary btn-grid"
                                  onClick={() => {
                                    IBBProgramSectionGetCompleteGridDataCustom(
                                      item.IBBProgramID
                                    );
                                    IBBProgramPFIDealerGetCompleteGridDataCustom(
                                      item.IBBProgramID
                                    );
                                    setCurrentView(3);
                                    setProgramData(item);
                                    if (item.Status == 0) {
                                      setCanEdit(true);
                                      setRequiredApprovalUser([]);
                                    } else {
                                      setCanEdit(false);
                                      IBBRequiredApprovalUserGetDataForApproval(
                                        item.IBBProgramID,
                                        item.SubStatus
                                      );
                                    }
                                  }}
                                  title={
                                    item.Status == 0 ? "Edit " : "View Details"
                                  }
                                >
                                  <img
                                    src="images/edit.svg"
                                    width={15}
                                    height={15}
                                  />
                                </a>
                              )}
                              {item.Status == 0 &&
                                getAccessSettings(2, 18) > 1 && (
                                  <>
                                    <a
                                      className="btn-primary btn-grid"
                                      // onClick={() => {
                                      //   IBBProgramDeleteRecordCustom(
                                      //     item.IBBProgramID
                                      //   );
                                      // }}
                                      onClick={() => {
                                        globalState.setConfirmationObject({
                                          ShowPopup: true,
                                          Heading: "Confirmation ",
                                          Message:
                                            "Are you sure you want to delete this record?",
                                          ID: 1,
                                          SelectedID: item.IBBProgramID,
                                        });
                                      }}
                                      title="Delete"
                                    >
                                      <img
                                        src="images/delete.svg"
                                        width={15}
                                        height={15}
                                      />
                                    </a>
                                  </>
                                )}
                              <a
                                className="btn-primary btn-grid"
                                title="View"
                                href={
                                  "programdashboard?pid=" + item.IBBProgramID
                                }
                              >
                                <img
                                  src="images/eye.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>
                              {/* TODO :: MM: change the below check to 2 */}
                              {item.Status < 20 &&
                                getAccessSettings(2, 18) > 1 && (
                                  <>
                                    <a
                                      className="btn-primary btn-grid btn-secs"
                                      href={
                                        "scorecard?pid=" +
                                        item.IBBProgramID +
                                        "&ms=1"
                                      }
                                    >
                                      Manage Sections
                                    </a>
                                  </>
                                )}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>

              <table
                className="part-head trend-table fixed-table no-display"
                id="tblProgramList"
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    {/* <th>Description</th> */}
                    <th>Total Percentage</th>
                    <th>Importer #</th>
                    <th>Year</th>
                  </tr>
                </thead>
                <tbody>
                  {programGridData &&
                    programGridData.map((item: any, index: any) => (
                      <React.Fragment key={"program" + index}>
                        <tr>
                          <td>{item.Name}</td>
                          {/* <td>{item.Description}</td> */}
                          <td className="text-right">
                            {item.TotalPercentage?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })}
                          </td>
                          <td className="text-right">{item.ImporterCount}</td>
                          <td className="text-right">{item.NumericYear}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(currentView == 2 || currentView == 3 || currentView == 4) && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Program</a>}
            {currentView == 3 && canEdit && <a>Edit Program</a>}
            {!canEdit && <a>Program Details</a>}
          </div>
          <div className="page--data">
            <div className="program-form">
              <div className="form-item">
                <span>Program:</span>
                <input
                  type="text"
                  value={programData.Name}
                  onChange={(e) =>
                    setProgramData((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="form-item">
                <span>Year:</span>
                <select
                  disabled={currentView == 4 || !canEdit ? true : false}
                  className="select-md"
                  value={programData.NumericYear}
                  onChange={(e) =>
                    setProgramData((prevState: any) => ({
                      ...prevState,
                      NumericYear: Number(e.target.value),
                    }))
                  }
                >
                  {AppContext.YearList &&
                    AppContext.YearList.map((Item: any, index: any) => (
                      <>
                        <option value={Item.PID} key={"year" + Item.PID}>
                          {Item.Name}
                        </option>
                      </>
                    ))}
                </select>
              </div>

              <div className="form-btns">
                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() => IBBProgramSaveCustom([])}
                >
                  Save
                </a>

                {canEdit && (
                  <>
                    {programData.IBBProgramID > 0 && (
                      <>
                        <a
                          className="btn-primary btn-grid btn-secs"
                          onClick={() =>
                            setSubmitForApprovalConfirmationModal(true)
                          }
                        >
                          Submit for Approval
                        </a>
                        <a
                          className="btn-primary btn-grid btn-secs"
                          href={
                            "approvalsettings?pid=" + programData.IBBProgramID
                          }
                          target="_blank"
                        >
                          Approval Settings
                        </a>
                      </>
                    )}
                  </>
                )}
                {currentView != 4 && (
                  <a
                    className="btn-primary btn-grid btn-secs"
                    onClick={() => {
                      setCurrentView(1);
                      IBBProgramGetCompleteGridDataCustom();
                    }}
                  >
                    Back to List View
                  </a>
                )}
              </div>
            </div>

            {programData.IBBProgramID > 0 && (
              <>
                <div className="p-list-grid">
                  <div>
                    {programSectionGridData &&
                      programSectionGridData.map((item: any, index: any) => (
                        <>
                          {item.Type > 0 && (
                            <React.Fragment key={"programSection" + index}>
                              <div className="lists-flex">
                                <span className="list-title">
                                  <span>{index + 1}.</span>
                                  <span>
                                    {item.Title}
                                    {item.ShortTitle &&
                                      item.ShortTitle != "" && (
                                        <>
                                          {" "}
                                          &nbsp;(
                                          {item.ShortTitle})
                                        </>
                                      )}
                                  </span>
                                </span>
                                <div className="list-flex-inner">
                                  <span>
                                    {item.Value?.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                    })}
                                    %
                                  </span>
                                  {canEdit && (
                                    <div className="ed-list">
                                      <a
                                        onClick={() => {
                                          let itemLocal = item;
                                          itemLocal.TotalPercentage =
                                            programSectionData.TotalPercentage;
                                          setProgramSectionData(itemLocal);
                                          setProgramSectionModal(true);
                                        }}
                                      >
                                        <img
                                          src="images/edit.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                      <a
                                        // onClick={() => {
                                        //   IBBProgramSectionDeleteRecordCustom(
                                        //     item.IBBProgramSectionID
                                        //   );
                                        // }}
                                        onClick={() => {
                                          globalState.setConfirmationObject({
                                            ShowPopup: true,
                                            Heading: "Confirmation ",
                                            Message:
                                              "Are you sure you want to delete this record?",
                                            ID: 2,
                                            SelectedID:
                                              item.IBBProgramSectionID,
                                          });
                                        }}
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </>
                      ))}
                    {canEdit && (
                      <div className="add-list-item">
                        <a
                          title="Add Section"
                          onClick={() => {
                            let programSectionDataLocal = {} as any;
                            programSectionDataLocal.Value = 0;
                            programSectionDataLocal.Type = 1;
                            programSectionDataLocal.IBBDepartmentID = 0;
                            if (programSectionGridData.length > 0)
                              programSectionDataLocal.Type = 2;
                            setProgramSectionData(programSectionDataLocal);
                            setProgramSectionModal(true);
                          }}
                        >
                          <img
                            src="images/add-black.svg"
                            width={30}
                            height={30}
                          />
                        </a>
                      </div>
                    )}

                    {programSectionGridData &&
                      programSectionGridData.length > 0 && (
                        <>
                          {canEdit ? (
                            <div className="lists-flex lists-flex-total">
                              <span className="list-title">Total</span>
                              <div className="list-flex-inner">
                                <span>
                                  {programSectionData.TotalPercentage?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                  %
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="lists-flex lists-flex-total-zero">
                              <span className="list-title">Total</span>
                              <div className="list-flex-inner">
                                <span>
                                  {programSectionData.TotalPercentage?.toLocaleString(
                                    undefined,
                                    { minimumFractionDigits: 2 }
                                  )}
                                  %
                                </span>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                  </div>
                  <div className="pg-importers appr-grid">
                    <div className="appr-main">
                      <div className="appr-head">
                        <span>Program Policy</span>
                      </div>
                      <div className="plr-20" style={{ paddingBottom: 20 }}>
                        <div className="flex-items supp-doc">
                          <span>Program Policy Document:</span>
                        </div>
                        <div className="flex-items">
                          <DragDrop
                            ParentFeatures={dragDropFeatures}
                            DragDropCallback={handleDragDropCallback}
                            TriggerChild={triggerChild}
                          />

                          <div className="help-btns" style={{ margin: 0 }}>
                            <a
                              onClick={() =>
                                showPopUpForSaveFiles(
                                  AppContext.FileUploadObjectTypeProgramPolicy,
                                  programData.IBBProgramID
                                )
                              }
                            >
                              Upload
                            </a>
                          </div>
                        </div>
                        <div className="flex-items" style={{ marginTop: 20 }}>
                          <div className="flex-items supp-doc">
                            <span>Attached Document:</span>
                          </div>
                          {programData.Description && (
                            <span
                              className="buis-head"
                              style={{
                                position: "relative",
                                background: "#eee",
                                padding: 7,
                                borderRadius: 2,
                              }}
                            >
                              <a
                                href={programData.Description}
                                target="blank"
                                title="Click To Download Program Policy Document"
                              >
                                <img
                                  src="images/pdf.svg"
                                  width={40}
                                  height={40}
                                />
                              </a>
                              <a
                                style={{
                                  position: "absolute",
                                  top: -3,
                                  right: 4,
                                }}
                                title="Delete"
                                onClick={() => {
                                  IBBProgramSaveCustom([]);
                                }}
                              >
                                <img
                                  src="images/close.svg"
                                  width={10}
                                  height={10}
                                />
                              </a>
                            </span>
                          )}
                        </div>

                        {programData.SubStatus == 5 && (
                          <div className="help-btns">
                            <a
                              style={{ width: 140 }}
                              onClick={() =>
                                sendProgramPolicyDocumentToImporters()
                              }
                            >
                              Send to Importers
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid-box-ibb">
                  <div className="pg-importers appr-grid">
                    <div className="appr-main">
                      <div className="appr-head">
                        <span>Importers in this program</span>

                        <div className="ed-list">
                          <a
                            title="Manage Importers"
                            onClick={() => {
                              setProgramPFIDealerModal(true);
                            }}
                          >
                            <img src="images/edit.svg" width={15} height={15} />
                          </a>
                        </div>
                      </div>
                      <div
                        className="pg-importers-table"
                        style={{
                          paddingTop: 5,
                          paddingBottom: 10,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        {programPFIDealerGridData &&
                          programPFIDealerGridData.length > 0 && (
                            <div className="section-table">
                              <table
                                className="part-head trend-table fixed-table"
                                id="tblData"
                              >
                                <thead>
                                  <tr>
                                    <th>Market</th>
                                    <th>Importer</th>
                                    {/* <th>Formula</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {programPFIDealerGridData &&
                                    programPFIDealerGridData.map(
                                      (item: any, index: any) => (
                                        <React.Fragment
                                          key={"programPFIDealergrid" + index}
                                        >
                                          <tr>
                                            <td>{item.MarketName}</td>
                                            <td>{item.DealerName}</td>
                                            {/* <td>
                                              {item.IBBFormulaIDForJaguarName}
                                            </td> */}
                                          </tr>
                                        </React.Fragment>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {programSectionModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Add Section</h3>
                <a
                  className="close-help"
                  onClick={() => setProgramSectionModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="help-row">
                <p>Type:</p>
                <select
                  key={"SectionTypeDDL"}
                  className="input-field select-field"
                  value={programSectionData.Type}
                  onChange={(e) => {
                    setProgramSectionData((prevState: any) => ({
                      ...prevState,
                      Type: e.target.value,
                    }));
                  }}
                >
                  <option value="0">Please Select</option>
                  <option value="1">Gateway</option>
                  <option value="2">Criteria</option>
                </select>
              </div>

              {programSectionData.Type == 2 && (
                <>
                  <div className="help-row">
                    <p>Functional Area:</p>
                    <select
                      key={"DepartmentDDL"}
                      className="input-field select-field"
                      value={programSectionData.IBBDepartmentID}
                      onChange={(e) => {
                        setProgramSectionData((prevState: any) => ({
                          ...prevState,
                          IBBDepartmentID: e.target.value,
                        }));
                      }}
                    >
                      <option value="0">Please Select</option>
                      {departmentList &&
                        departmentList.map((item: any, index: any) => (
                          <React.Fragment key={"departmentlist" + index}>
                            <option
                              value={item.IBBDepartmentID}
                              key={"department" + item.IBBDepartmentID}
                            >
                              {item.Name}
                            </option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                </>
              )}

              <div className="help-row">
                <p>Title:</p>
                <input
                  value={programSectionData.Title}
                  onChange={(e) =>
                    setProgramSectionData((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="help-row">
                <p>Short Title:</p>
                <input
                  value={programSectionData.ShortTitle}
                  onChange={(e) =>
                    setProgramSectionData((prevState: any) => ({
                      ...prevState,
                      ShortTitle: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="help-row">
                <p>Description:</p>
                <input
                  value={programSectionData.Description}
                  onChange={(e) =>
                    setProgramSectionData((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              {programSectionData.Type == 2 && (
                <>
                  <div className="help-row">
                    <p>Value:</p>
                    <input
                      value={programSectionData.Value}
                      onChange={(e) =>
                        setProgramSectionData((prevState: any) => ({
                          ...prevState,
                          Value: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Value Description:</p>
                    <input
                      value={programSectionData.ValueDescription}
                      onChange={(e) =>
                        setProgramSectionData((prevState: any) => ({
                          ...prevState,
                          ValueDescription: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Order By:</p>
                    <input
                      value={programSectionData.PTOrderBy}
                      onChange={(e) =>
                        setProgramSectionData((prevState: any) => ({
                          ...prevState,
                          PTOrderBy: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Weightage:</p>
                    <select
                      className="input-field select-field"
                      value={programSectionData.ExtraTextField1}
                      onChange={(e) =>
                        setProgramSectionData((prevState: any) => ({
                          ...prevState,
                          ExtraTextField1: e.target.value,
                        }))
                      }
                    >
                      <option value="-1">Please Select</option>
                      <option value="0">Split Percentage</option>
                      <option value="1">All Or Nothing</option>
                    </select>
                  </div>
                </>
              )}

              <div className="help-btns">
                <a onClick={() => IBBProgramSectionSaveCustom()}>Save</a>
                <a onClick={() => setProgramSectionModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {programPFIDealerModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Manage Importers</h3>
                <a
                  className="close-help"
                  onClick={() => setProgramPFIDealerModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              {PFIDealerGridData && (
                <div className="section-table manage-i-table">
                  <table
                    className="part-head trend-table fixed-table"
                    id="tblData"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 40 }}>
                          <input
                            type="checkbox"
                            value={selectUnSelectAll}
                            checked={selectUnSelectAll}
                            onChange={(e: any) => selectUnselectAll(e)}
                          />
                        </th>
                        <th style={{ width: 100 }}>Market</th>
                        <th>Importer</th>
                        {/* <th style={{ width: 110 }}>Formula</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {PFIDealerGridData &&
                        PFIDealerGridData.map((item: any, index: any) => (
                          <React.Fragment key={"programPFIDealer" + index}>
                            <tr>
                              <td style={{ textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  className="input-check"
                                  checked={item.IsChecked}
                                  onChange={(e) =>
                                    updateImporterListInProgram(
                                      index,
                                      1,
                                      !item.IsChecked
                                    )
                                  }
                                />
                              </td>
                              <td>{item.MarketName}</td>
                              <td>{item.DealerName}</td>
                              {/* <td>
                                {ibbFormulaGridData && (
                                  <select
                                    key={"FormulaSelect"}
                                    className="input-field select-field"
                                    value={item.IBBFormulaIDForJaguar}
                                    onChange={(e) => {
                                      updateImporterListInProgram(
                                        index,
                                        2,
                                        e.target.value
                                      );
                                    }}
                                  >
                                    <option value="0">Please Select</option>
                                    {ibbFormulaGridData.map(
                                      (Item: any, index: any) => (
                                        <option
                                          value={Item.IBBFormulaID}
                                          key={
                                            "FormulaOption" + Item.IBBFormulaID
                                          }
                                        >
                                          {Item.Name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                )}
                              </td> */}
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {submitForApprovalConfirmationModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setSubmitForApprovalConfirmationModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="pl-pop-txt">
                Please make sure you have updated the Approval settings for this
                program. Click{" "}
                <a
                  href={"approvalsettings?pid=" + programData.IBBProgramID}
                  target="_blank"
                >
                  here
                </a>{" "}
                to see the settings.{" "}
              </div>
              <div className="pl-pop-txt text-center">
                <b>Are you sure you want to send this program for approval?</b>
              </div>
              <div className="help-btns">
                <a onClick={() => IBBProgramUpdateStatusAndSubStatus(1, 3)}>
                  Yes
                </a>
                <a onClick={() => setSubmitForApprovalConfirmationModal(false)}>
                  No
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {approvalDataModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setApprovalDataModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">
                <span className="buis-head">Comments</span>
                <textarea
                  value={approvalData.Notes}
                  onChange={(e) => {
                    setApprovalData((prevState: any) => ({
                      ...prevState,
                      Notes: e.target.value,
                    }));
                  }}
                ></textarea>
                <div className="flex-items supp-doc">
                  <span>Supporting Document:</span>
                  <div className="order-drag">
                    <DragDrop
                      ParentFeatures={dragDropFeatures}
                      DragDropCallback={handleDragDropCallback}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </div>
              </div>
              <div className="help-btns">
                <div>
                  Are you sure you want to{" "}
                  <b>{approvalData.Status == 1 ? "Approve" : "Reject"}</b> it?
                  You will not be able to revert it.
                </div>
                <a
                  onClick={() => {
                    showPopUpForSaveFiles(
                      AppContext.FileUploadObjectTypeApprovalFile,
                      approvalData.IBBRequiredApprovalUserID
                    );
                  }}
                >
                  Yes
                </a>
                <a onClick={() => setApprovalDataModal(false)}>No</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProgramList;
